<template>
  <div id="app" class="col-md-5 col-xs-12 col-sm-12 col-12">
    <h1 class="big-title login-title" style="text-align: center;">
      {{ $t('m19') }}
    </h1>

    <a-btn
      @click="goToCreateUser"
      secondary
      prepend-icon="ic-mail"
      class="login-rrss-button"
    >
      {{ $t('m19') }}
    </a-btn>
  </div>
</template>

<script>
import ABtn from '@/components/ui/ABtn';
import ALink from '@/components/ui/ALink';
import { socialLogin } from '@/mixins/socialLogin.js';
import GoogleLogin from 'vue-google-login';

export default {
  components: {
    ABtn,
    ALink,
    GoogleLogin,
  },
  mixins: [socialLogin],
  methods: {
    goToCreateUser() {
      this.$store.dispatch('register/setRegistrationStep', 'CREATE_USER');
      this.$router.push({ name: 'CREATE_USER' });
    },
  },
  computed: {
    social() {
      return this.$store.getters['visualResources/socialLogin'];
    },
  },
};
</script>
